import type JournalEventModel from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";

export interface das28Je extends JournalEventModel {
  nad: number;
  nag: number;
  patientFeeling: number;
}

export default function getAllDas28Jes(patient: Patient): das28Je[] {
  const answer = [
    ...patient.das28CdaiComputedJournalEvents,
    ...patient.das28CrpComputedJournalEvents,
    ...patient.das28SdaiComputedJournalEvents,
    ...patient.das28VsComputedJournalEvents
  ];
  return answer;
}
